/* eslint-disable jsx-a11y/anchor-is-valid */

import 'react-bootstrap';
import jQuery from "jquery";
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './component/Footer';
import {BrowserRouter as Router, Route , Switch } from 'react-router-dom';

import About from './pages/About/About-us';
import Contact from './pages/Contact/Contact';
import Managment from './pages/Managment/Managment';
import Maintenance from './pages/Maintenance/Maintenace';
import EnergieRenv from './pages/Energie-renv/Energie-Renouvable';
import ScrollToTop from './component/ScrollToTop';
import Environment from './pages/Environment/Environment';


import './App.css'
import Home from './pages/Home/Home';
import Navbarr from './component/Navbar/Navbarr';
import FlagButton from './component/Reactflag/FlagButton'


(function ($) {
  
  
  // Back to top button
  $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
          $('.back-to-top').fadeIn('slow');
      } else {
          $('.back-to-top').fadeOut('slow');
      }
  });
  $('.back-to-top').click(function () {
      $('html, body').animate({scrollTop: 0}, 1500, 'easeInOutExpo');
      return false;
  });
  
  
})(jQuery);

function App() {
  
  return (
    <div >
       <FlagButton/>
      <Router>
        <ScrollToTop/>
      <Navbarr/>
      
       <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/About-us" component={About}/>
        <Route exact path="/maintenance" component={Maintenance}/>
        <Route exact path="/energie-renouvable" component={EnergieRenv}/>
        <Route exact path="/management" component={Managment}/>
        <Route exact path="/Environment" component={Environment}/>
      
        <Route exact path="/contact" component={Contact}/>
       </Switch>
      <Footer/>
      </Router>
      <a href="#" className="back-to-top" style={{display:"inline"}} ><i className="fa fa-chevron-up"></i></a>
      
    </div>
  );
}

export default App;
